<script setup lang="ts">
import type {
  Attachment,
  FineUploaderUpload,
} from '@/models/current-student-advanced-standing-form/api'
import FineUploaderModalUpload from '@/components/current-student-advanced-standing-form/upload/FineUploaderModalUpload.vue'
import SavedAttachmentTable from '@/components/current-student-advanced-standing-form/upload/SavedAttachmentTable.vue'

defineProps<{
  currentSubjectAttachments: Attachment[]
  subjectAttachmentDeleteIds: number[]
  showSubjectFineUploader: boolean
  visibleSubjectNewAttachments: FineUploaderUpload[]
  subjectUploadDropActive: boolean
  subjectUploadAlertMessage: string
  uploadThumbnailUrl: (attachment: FineUploaderUpload) => string
}>()

const emit = defineEmits<{
  stageSubjectAttachmentDelete: [attachment: Attachment]
  subjectUploadDragEnter: [event: DragEvent]
  subjectUploadDragOver: [event: DragEvent]
  subjectUploadDragLeave: [event: DragEvent]
  subjectUploadDrop: [event: DragEvent]
  triggerUploadInput: [event: MouseEvent]
  uploadButtonKeydown: [event: KeyboardEvent]
  uploadButtonHover: [event: MouseEvent, hover: boolean]
  uploadButtonFocus: [event: FocusEvent, focused: boolean]
  subjectAttachmentSelected: [event: Event]
  cancelStagedUpload: [attachment: FineUploaderUpload]
  retrySubjectAttachment: [attachment: FineUploaderUpload]
  deleteStagedSubjectAttachment: [attachment: FineUploaderUpload]
  closeSubjectUploadAlert: []
}>()
</script>

<template>
              <div class="form-field">
                <label>Attachments</label>
                <SavedAttachmentTable
                  tbody-id="subjectAttachmentUploadTable"
                  :attachments="currentSubjectAttachments"
                  :deleted-attachment-ids="subjectAttachmentDeleteIds"
                  @stage-delete="emit('stageSubjectAttachmentDelete', $event)"
                />
              </div>

              <div class="form-field">
                <FineUploaderModalUpload
                  uploader-id="subjectAttachmentFineUploader"
                  :visible="showSubjectFineUploader"
                  :attachments="visibleSubjectNewAttachments"
                  :drop-active="subjectUploadDropActive"
                  :alert-message="subjectUploadAlertMessage"
                  :upload-thumbnail-url="uploadThumbnailUrl"
                  @drag-enter="emit('subjectUploadDragEnter', $event)"
                  @drag-over="emit('subjectUploadDragOver', $event)"
                  @drag-leave="emit('subjectUploadDragLeave', $event)"
                  @drop="emit('subjectUploadDrop', $event)"
                  @trigger-upload-input="emit('triggerUploadInput', $event)"
                  @upload-button-keydown="emit('uploadButtonKeydown', $event)"
                  @upload-button-hover="(event, hover) => emit('uploadButtonHover', event, hover)"
                  @upload-button-focus="(event, focused) => emit('uploadButtonFocus', event, focused)"
                  @file-selected="emit('subjectAttachmentSelected', $event)"
                  @cancel-staged-upload="emit('cancelStagedUpload', $event)"
                  @retry-upload="emit('retrySubjectAttachment', $event)"
                  @delete-staged-upload="emit('deleteStagedSubjectAttachment', $event)"
                  @close-alert="emit('closeSubjectUploadAlert')"
                />
              </div>
</template>
